import React from 'react'
import moment from "moment";
import {checkPermission} from "../../../../../utils/common";
import Pagination from "../../../../../components/Pagination";
import TableHeader from "../../../../../components/TableHeader";
import AdSchoolInfoManager from "../../../../../services/system/school-info/ad-school-info-manager";
import ModalCreateClass from './modalCreateClass'
import ModalEditClass from './modalEditClass'
import ModalDeleteClass from './modalDeleteClass'
import ClassController from "../../../../../services/data-declaration/class-controller";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import {getSchoolYear} from "../../../../../utils/authority";
import GradeManager from "../../../../../components/Grade";

class ClassManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            pageNumber: 0,
            pageSize: 10,
            totalItem: '',
            sort: '',
            categoryType:  "ALL",
            listData: [],
            itemSelected: "",
            showModalDelete: false,
            showModalCreate: false,
            showModalEdit: false,
            showLoading: false,
            header: [
                {
                    id: 'id',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'name',
                    name: 'Tên lớp',
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'teacher',
                    name: "Giáo viên chủ nhiệm",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'action',
                    name: "Thao tác",
                    style: {textAlign: "center"},
                    sort: false
                },
            ],
        }
    }
    componentDidMount() {
        this.getListClassRoom()
    }

    onSearch = () => {
        let payload = {
            name: "",
            grade: this.state.grade,
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClassRoom()
        });
    }
    getListClassRoom = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    };

    handleChangePage = (page) => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListClassRoom()
            }
        );
    };
    render() {
        let {pageNumber, pageSize, gradeId} = this.state;
        return (
            <div>
                <div className="row">
                    <div className="mb-4 col-md-12 tab-content">
                        {this.state.showLoading &&
                        <div className="content-loading col-12 ml-3 align-items-center"
                             style={{display: 'block'}}>
                            <div className="spinner-grow text-info"/>
                        </div>
                        }
                        <div className="col-12">
                            <div className='mb-4'>
                                <div className="kt-form kt-form--fit">
                                    <div className="row">
                                        <div className='col-xs-6 col-sm-6 col-md-6 text-left pl-0 mt-3 row'>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Khối</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                        </div>
                                        <div className='col-xs-6 col-sm-6 col-md-6 text-left pl-0 mt-3'>
                                            <button
                                                type="button"
                                                className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                title='Thêm mới'
                                                style={{cursor: 'pointer', float: 'right'}}
                                                onClick={() => {
                                                    this.setState({itemSelected: -1, showModalCreate: true})
                                                }}
                                            >
                                                Thêm mới
                                            </button>
                                            {checkPermission("create_new_school_year") &&
                                                <button
                                                    type="button"
                                                    className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                    title='Thêm mới'
                                                    style={{cursor: 'pointer', float: 'right'}}
                                                    onClick={() => {
                                                        console.log("Out/In")
                                                    }}
                                                >
                                                    Nhập xuất
                                                </button>
                                            }
                                            {checkPermission("create_new_school_year") &&
                                                <button
                                                    type="button"
                                                    className="border-1-s mr-2 background-btn type-button-fix btn btn-primary btn-sm shadow-none"
                                                    title='Thêm mới'
                                                    style={{cursor: 'pointer', float: 'right'}}
                                                    onClick={() => {
                                                        console.log("Updaet STT")
                                                    }}
                                                >
                                                    Cập nhật STT
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-wrapper">
                                <table className="table table-striped table-data table-bordered">
                                    <thead>
                                    <TableHeader header={this.state.header} clickSort={(data) => {
                                        let a = '';
                                        if (data.sortAsc == null) {
                                            a = ''
                                        } else {
                                            a = `id_sort=${data.sortAsc ? 'asc' : 'desc'}`;
                                        }
                                        this.setState({
                                            sort: a
                                        }, () => this.getListClassRoom())
                                    }}/>
                                    </thead>
                                    {!this.state.listData || this.state.listData.length == 0
                                        ? <tbody>
                                        <tr>
                                            <td colSpan={12}>
                                                <div className='text-center'>Không có dữ liệu</div>
                                            </td>
                                        </tr>
                                        </tbody>
                                        : <tbody>
                                        {this.state.listData.map((row, index) => (
                                            <tr key={row.id} style={{height: 50}}>
                                                <td style={{textAlign: 'center'}}>{pageNumber * pageSize + index + 1}</td>
                                                <td style={{textAlign: 'left',}}>
                                                    {row.name}
                                                </td>
                                                <td style={{textAlign: 'center'}}>
                                                    {row.headTeacherRes?.fullName}
                                                </td>
                                                <td className='p-1' style={{textAlign: 'center'}}>
                                                    <button className="btn btn-action p-2"
                                                            title='Sửa'
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => {
                                                                this.setState({itemSelected: row.id, showModalEdit: true})
                                                            }}
                                                    >
                                                        <i className="ti-pencil-alt"/>
                                                    </button>
                                                    <button className="btn btn-action p-2"
                                                            title='Xóa'
                                                            style={{cursor: 'pointer'}}
                                                            onClick={() => {
                                                                this.setState({itemSelected: row.id, showModalDelete: true})
                                                            }}
                                                    >
                                                        <i className="ti-trash"/>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>}
                                </table>
                            </div>
                            <div className="pagination-right">
                                <Pagination
                                    activePage={this.state.pageNumber}
                                    itemsCountPerPage={this.state.pageSize}
                                    totalItemsCount={this.state.totalItem}
                                    changeHandler={(page) => this.handleChangePage(page)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <ModalDeleteClass
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.getListClassRoom()}
                    id={this.state.itemSelected}
                />

                <ModalCreateClass
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getListClassRoom()}
                    id={this.state.itemSelected}
                />

                <ModalEditClass
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.getListClassRoom()}
                    id={this.state.itemSelected}
                />
            </div>
        )
    }

}

export default ClassManagement
